<template>
  <div class="option-management">
    <div class="options-header">
      <div class="header-icon">
        <slot name="icon"></slot>
      </div>
      <div class="header-action">
        <slot name="action"></slot>
      </div>
    </div>
    <ul class="options-list">
      <slot></slot>
    </ul>
    <div class="options-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'options-management'
}
</script>

<style scoped lang="scss">
.option-management {
  background-color: $white;
  border-radius: 5px;
  overflow: hidden;

  .options-header {
    padding: 1.2rem 2.4rem;
    border-bottom: 1px solid $grey;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.06);
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-icon {
      max-width: 32px;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  .options-list {
    list-style: none;
    padding: 0 2.4rem;
    margin: 0;
    background-color: $white;
  }

  .options-footer {
    padding: 1.2rem 2.4rem;
  }
}
</style>
